import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import useClaimedArtist from '../artists/hooks/useClaimedArtist';
// Parked Bucket Lists — restore unlock + FEATURE_BUCKET_LISTS import to show the tab again.
// import { FEATURE_BUCKET_LISTS } from '../../services/users/levelUnlocks';
// import useLevelUnlock from '../../utils/useLevelUnlock';
import './ProfileSubNav.css';

function padStat(n) {
  const v = Math.max(0, Math.floor(Number(n) || 0));
  return v < 10 ? `0${v}` : String(v);
}

/**
 * Secondary bar above PublicBottomNav on Profile routes.
 * Tabs: Profile · My drops · Shop · Artist (claimed only).
 * Bucket Lists (Lv 2) is parked — restore `useLevelUnlock(FEATURE_BUCKET_LISTS)`.
 */
const ProfileSubNav = ({ dropsCreated = 0 }) => {
  const { currentUser } = useAuth();
  const { artist } = useClaimedArtist(currentUser?.uid);
  const showArtist = Boolean(artist?.id);
  // const showBucketLists = useLevelUnlock(FEATURE_BUCKET_LISTS);
  const showBucketLists = false;
  const innerClass = [
    'profile-subnav__inner',
    showBucketLists ? 'profile-subnav__inner--bucket' : '',
    showArtist ? 'profile-subnav__inner--artist' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <nav className="profile-subnav" aria-label="Profile sections">
      <div className={innerClass}>
        <NavLink
          to="/profile"
          end
          className={({ isActive }) =>
            `profile-subnav__tab${isActive ? ' is-active' : ''}`
          }
        >
          Profile
        </NavLink>
        <NavLink
          to="/profile/mine"
          className={({ isActive }) =>
            `profile-subnav__tab profile-subnav__tab--with-stats${
              isActive ? ' is-active' : ''
            }`
          }
          aria-label={`My drops, ${dropsCreated} created`}
        >
          My drops
          <span className="profile-subnav__stats" aria-hidden="true">
            {padStat(dropsCreated)}
          </span>
        </NavLink>
        <NavLink
          to="/shop"
          className={({ isActive }) =>
            `profile-subnav__tab${isActive ? ' is-active' : ''}`
          }
        >
          Shop
        </NavLink>
        {showBucketLists ? (
          <NavLink
            to="/sidequests"
            className={({ isActive }) =>
              `profile-subnav__tab${isActive ? ' is-active' : ''}`
            }
          >
            Bucket Lists
          </NavLink>
        ) : null}
        {showArtist ? (
          <NavLink
            to="/profile/artist"
            className={({ isActive }) =>
              `profile-subnav__tab${isActive ? ' is-active' : ''}`
            }
          >
            Artist
          </NavLink>
        ) : null}
      </div>
    </nav>
  );
};

export default ProfileSubNav;
